export default {"src":"/_next/static/media/next-js-logo.2b40772a.svg","height":58,"width":96,"blurWidth":0,"blurHeight":0};